const SECONDS_PER_LESSON = 61 / 200
const MARGIN = 1.1

export function matchEtaSeconds(lessonCount: number): number {
  const n = Math.max(0, Math.floor(lessonCount || 0))
  return Math.max(15, Math.round(n * SECONDS_PER_LESSON * MARGIN))
}

export function formatMatchEta(lessonCount: number): string {
  const s = matchEtaSeconds(lessonCount)
  const m = Math.floor(s / 60)
  const r = s % 60
  const minPart = m === 1 ? '1 Minute' : `${m} Minuten`
  const secPart = r === 1 ? '1 Sekunde' : `${r} Sekunden`
  if (m === 0) return `ca. ${secPart}`
  if (r === 0) return `ca. ${minPart}`
  return `ca. ${minPart} ${secPart}`
}
